<template>
  <div>
    <div class="col-12">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-1">
              <channel-icon :channel="channel" class="rounded-circle w-30-p"></channel-icon>
            </div>
            <div class="col-6 col-xl-7">
              <h4 class="m-0 text-truncate">{{ channel.name }}</h4>
            </div>
            <div class="col-4 col-xl-3 d-flex align-items-center">
              <strong>ID:</strong><span class="ml-1 text-muted">{{ channel.id }}</span>
            </div>
          </div>
        </div>
        <div class="position-absolute left-auto right-0">
          <button type="button" class="btn btn-danger mr-2" @click="openDeleteConfirm">
            <icon class="btn-icon" name="trash" :inverse="true"/>
            Delete Channel
          </button>
        </div>
      </div>
    </div>
    <modal-confirm-delete
      :showModal="showDeleteModal"
      @channelDeleted="$router.push({ name: 'administration.channels'})"
      :channel="channel">
    </modal-confirm-delete>
  </div>
</template>

<script>
  import ChannelIcon from '@/components/common/ChannelIcon'
  import ConfirmDelete from './ConfirmDeleteChannel'
  import 'vue-awesome/icons/trash'
  import 'vue-awesome/icons/arrow-left'

  export default {
    components: {
      'modal-confirm-delete': ConfirmDelete,
      'channel-icon': ChannelIcon
    },

    store: {
      channel: 'administration.channelDetail.channel',
      showDeleteModal: 'administration.channelDetail.showDeleteModal'
    },

    methods: {
      openDeleteConfirm() {
        this.showDeleteModal = true
      }
    }
  }
</script>
